import { EPrescribePharmacy } from "src/api/types";

export const formattedPharmacyAddress = (pharmacy: EPrescribePharmacy) => {
  return [
    pharmacy.Address1,
    pharmacy.Address2,
    pharmacy.City,
    pharmacy.State,
    pharmacy.ZipCode,
  ]
    .filter(Boolean)
    .join(", ");
};
